import { useSettings } from "~/store/settings";
import { useBonusses } from "~/store/bonusses";

export const payoutLimitConfig = (count: number, paymentType: 1 | 2 | 4): { RangeFrom: number; RangeTo: number; PayoutLimit: number } | undefined => {
	const settings = useSettings();

	//Free be payout limits
	if (paymentType == 2) {
		return settings.config?.appSetting?.FreeBetPayoutLimits.find((x) => x.RangeTo >= count && x.RangeFrom <= count);
	} else if (paymentType == 4) {
		const bonuses = useBonusses();
		if (bonuses.activeSportBonus?.maxPayoutLimit) {
			return { RangeFrom: 0, RangeTo: 0, PayoutLimit: bonuses.activeSportBonus?.maxPayoutLimit };
		}
	}

	return settings.config?.appSetting?.PayoutLimits.find((x) => (count <= 1 ? x.RangeTo === 1 : x.RangeTo >= count && x.RangeFrom <= count));
};
